module.exports = __webpack_public_path__ + "img/30.d12205d7.jpg";